import { GetAdminVideoHostingQueryOutputProvider } from 'common/api/video-api-schema'
import { Video } from 'features/videos/service'

export const DEFAULT_LOCALE = 'ru'

export const trimValue = (value?: null | string) => value?.trim() ?? ''

export const trimOrUndefined = (value?: null | string) => {
  const trimmed = trimValue(value)

  return trimmed || undefined
}

export const mapLegacyHostingToProvider = (hosting?: Video['hosting']) => {
  switch (hosting) {
    case 'kinescope':
      return GetAdminVideoHostingQueryOutputProvider.KINESCOPE
    case 'vimeo':
      return GetAdminVideoHostingQueryOutputProvider.VIMEO
    case 'vk':
      return GetAdminVideoHostingQueryOutputProvider.VK
    case 'youtube':
    default:
      return GetAdminVideoHostingQueryOutputProvider.YOUTUBE
  }
}

export const mapProviderToLegacyHosting = (
  provider: GetAdminVideoHostingQueryOutputProvider
): Video['hosting'] => {
  switch (provider) {
    case GetAdminVideoHostingQueryOutputProvider.KINESCOPE:
      return 'kinescope'
    case GetAdminVideoHostingQueryOutputProvider.VIMEO:
      return 'vimeo'
    case GetAdminVideoHostingQueryOutputProvider.VK:
      return 'vk'
    case GetAdminVideoHostingQueryOutputProvider.YOUTUBE:
    default:
      return 'youtube'
  }
}
